import { UsersFormComponent } from './users-form.component';
import { ZohoCustomerLinkComponent } from './zoho-customer-link.component';

export const USER_COMPANY_COMPONENTS = [UsersFormComponent, ZohoCustomerLinkComponent];
